import React, { Component } from "react";
import cx from "classnames";
import styles from "./style.module.scss";

export default class SkeletonInput extends Component {
  render() {
    const { loading, className } = this.props;

    return (
      <>
        {loading ? (
          <div className={cx(styles.skeletonInput, className)} />
        ) : null}
      </>
    );
  }
}
